import { buildErrorMessage } from "@nimble/react-requests/helpers/error-message";
import { useMutation } from "@tanstack/react-query";

import coreApiClient from "@/lib/api-clients/core-api-client";
import { AUTH_ERROR_MESSAGES } from "@/lib/constants/auth-messages";

interface PasswordlessRegistrationRequest {
  email: string;
  agree_tos: boolean;
  signup_data?: Record<string, unknown>;
  signup_action?: string;
}

export default function usePasswordlessAuth() {
  return useMutation({
    mutationFn: async (request: PasswordlessRegistrationRequest) => {
      await coreApiClient
        .postApiAuthRegisterPasswordless({
          body: request,
        })
        .catch((error: unknown) => {
          throw new Error(
            buildErrorMessage(
              error,
              AUTH_ERROR_MESSAGES.passwordlessRegistrationFailed,
            ),
          );
        });
    },
  });
}
